import React from 'react'
import './footernew.css'

import { NavLink } from 'react-router-dom'
import { Container } from 'react-bootstrap'

import brandlogo from '../images/footer Brand Logo.svg'

import india from '../images/india.svg'
import ksa from '../images/ksa.svg'
import usa from '../images/usa.svg'

import location from '../images/footer_location-outline.svg'
import phone from '../images/footer_phone-outline.svg'


import linkedin from "../images/linkedin.webp";
// import instagram from "../images/instagram.webp";

const FooterNew = ({setBlank}) => {

const scrollToTop = () => {
        setBlank(true);
        setTimeout(() => {
        window.scrollTo(0, 0);
        }, 100);
        setTimeout(() => {
        setBlank(false);            
        }, 600);
    }

  return (
    <>
    <footer class="ps-footer">

  {/* <!-- Top Footer --> */}

  <Container>
  <div class="ps-footer__top">
    <div class="ps-footer__brand">

      <NavLink to="/" onClick={scrollToTop} class="ps-footer__logo">
        <img src={brandlogo} alt="Preferred Square" />
      </NavLink>

      <div class="ps-footer__emails">
        <NavLink to="mailto:info@preferredsquare.com">
          <span class="ps-footer__icon"><svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 0H1.83333C1.34737 0.000881162 0.88157 0.194318 0.537944 0.537944C0.194318 0.88157 0.000881162 1.34737 0 1.83333V8.83333C0.000881162 9.31929 0.194318 9.7851 0.537944 10.1287C0.88157 10.4723 1.34737 10.6658 1.83333 10.6667H11.5C11.986 10.6658 12.4518 10.4723 12.7954 10.1287C13.139 9.7851 13.3325 9.31929 13.3333 8.83333V1.83333C13.3325 1.34737 13.139 0.88157 12.7954 0.537944C12.4518 0.194318 11.986 0.000881162 11.5 0ZM1.83333 1H11.5C11.96 1 12.3333 1.37333 12.3333 1.83333V2.48333L6.66667 5.75667L1 2.48333V1.83333C1 1.37333 1.37333 1 1.83333 1ZM11.5 9.66667H1.83333C1.37333 9.66667 1 9.29333 1 8.83333V3.64L6.66667 6.91333L12.3333 3.64V8.83333C12.3333 9.29333 11.96 9.66667 11.5 9.66667Z" fill="#11E9C7"/>
</svg>
</span>
          info@preferredsquare.com
        </NavLink>

        <NavLink to="mailto:connect@preferredsquare.com">
          <span class="ps-footer__icon">
            <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 0H1.83333C1.34737 0.000881162 0.88157 0.194318 0.537944 0.537944C0.194318 0.88157 0.000881162 1.34737 0 1.83333V8.83333C0.000881162 9.31929 0.194318 9.7851 0.537944 10.1287C0.88157 10.4723 1.34737 10.6658 1.83333 10.6667H11.5C11.986 10.6658 12.4518 10.4723 12.7954 10.1287C13.139 9.7851 13.3325 9.31929 13.3333 8.83333V1.83333C13.3325 1.34737 13.139 0.88157 12.7954 0.537944C12.4518 0.194318 11.986 0.000881162 11.5 0ZM1.83333 1H11.5C11.96 1 12.3333 1.37333 12.3333 1.83333V2.48333L6.66667 5.75667L1 2.48333V1.83333C1 1.37333 1.37333 1 1.83333 1ZM11.5 9.66667H1.83333C1.37333 9.66667 1 9.29333 1 8.83333V3.64L6.66667 6.91333L12.3333 3.64V8.83333C12.3333 9.29333 11.96 9.66667 11.5 9.66667Z" fill="#11E9C7"/>
</svg></span>
          connect@preferredsquare.com
        </NavLink>
      </div>

    </div>


    {/* <!-- About --> */}
    <div class="ps-footer__column">
      <h3><NavLink to="/about" onClick={scrollToTop}>About Us</NavLink></h3>
    </div>


    {/* <!-- Services --> */}
    <div class="ps-footer__column">
      <h3><NavLink to="/service" onClick={scrollToTop}>Services</NavLink></h3>

      <ul>
        <li><NavLink to="/aidataService" onClick={scrollToTop}>AI &amp; Data Solutions</NavLink></li>
        <li><NavLink to="/managementconsultingservices" onClick={scrollToTop}>Management Consulting</NavLink></li>
        <li><NavLink to="/investmentadvisoryservice" onClick={scrollToTop}>Investment Advisory</NavLink></li>
        <li><NavLink to="/cfoservices" onClick={scrollToTop}>CFO Services</NavLink></li>
      </ul>
    </div>


    {/* <!-- Who We Serve --> */}
    <div class="ps-footer__column">
      <h3><NavLink to="/oursolution" onClick={scrollToTop}>Who we serve</NavLink></h3>
    </div>


    {/* <!-- Knowledge --> */}
    <div class="ps-footer__column">
      <h3><NavLink to="/knowledge" onClick={scrollToTop}>Knowledge</NavLink></h3>

      <ul>
        <li><NavLink to="/knowledge" onClick={scrollToTop}>Case studies</NavLink></li>
        <li><NavLink to="/knowledge" onClick={scrollToTop}>Insights</NavLink></li>
        <li><NavLink to="/knowledge" onClick={scrollToTop}>Blogs</NavLink></li>
      </ul>
    </div>


    {/* <!-- Careers --> */}
    <div class="ps-footer__column">
      <h3><NavLink to="/careers" onClick={scrollToTop}>Careers</NavLink></h3>

      <ul>
        <li><NavLink to="/careers" onClick={scrollToTop}>Life@ PS</NavLink></li>
        <li><NavLink to="/careers" onClick={scrollToTop}>Job openings</NavLink></li>
      </ul>
    </div>


    {/* <!-- Contact --> */}
    <div class="ps-footer__column">
      <h3><NavLink to="/contact" onClick={scrollToTop}>Contact Us</NavLink></h3>
    </div>
  </div>
</Container>


  {/* <!-- Locations --> */}
<Container>
  <div class="ps-footer__locations">

    {/* <!-- India --> */}
    <div class="ps-footer__location">

      <div class="ps-footer__location-title">
        <span class="ps-footer__flag"><img src={india} alt='india flag'/></span>
        <strong>India</strong>
      </div>

      <div class="ps-footer__address">
        <span class="ps-footer__location-icon"><img src={location} alt='location icon' /></span>

        <span>
          6th Floor, Building 4, Candor Tech Space, Sector<br />
          48, Gurgaon - 122018, Haryana, India
        </span>
      </div>

      <NavLink to="tel:+919810376994" class="ps-footer__phone">
        <span><img src={phone} alt='phone icon' /></span>
        +91 98103 76994
      </NavLink>

    </div>


    {/* <!-- KSA --> */}
    <div class="ps-footer__location">

      <div class="ps-footer__location-title">
        <span class="ps-footer__flag"><img src={ksa} alt='ksa flag'/></span>
        <strong>KSA</strong>
      </div>

      <div class="ps-footer__address">
        <span class="ps-footer__location-icon"><img src={location} alt='location icon' /></span>

        <span>
          Build. No. 6998, Al Olaya, Secondary No. 3609, Al- <br />
          Olaya Dist, Pin-12211, Riyadh, KSA
        </span>
      </div>

      <NavLink to="tel:+966552658012" class="ps-footer__phone">
        <span><img src={phone} alt='phone icon' /></span>
        +966 55 265 8012
      </NavLink>

    </div>


    {/* <!-- USA --> */}
    <div class="ps-footer__location">

      <div class="ps-footer__location-title">
        <span class="ps-footer__flag"><img src={usa} alt='usa flag' /></span>
        <strong>USA</strong>
      </div>

      <div class="ps-footer__address">
        <span class="ps-footer__location-icon"><img src={location} alt='location icon' /></span>

        <span>
          The Plaza at River Bend, 1220 River Bend Dr.<br />
          Suite 250 Dallas TX 75247, USA
        </span>
      </div>

      <NavLink to="tel:+19172823734" class="ps-footer__phone">
        <span><img src={phone} alt='phone icon' /></span>
        +1 917 282 3734
      </NavLink>

    </div>

  </div>
</Container>


  {/* <!-- Bottom Footer --> */}
  <Container>
  <div class="ps-footer__bottom">

    <div class="ps-footer__copyright">
      © 2026 Preferred Square Pvt Ltd | All rights reserved
    </div>

    <div class="ps-footer__social">

      {/* <NavLink to="#" aria-label="Instagram">
        <img src={instagram} alt=''/>
      </NavLink> */}

      <NavLink to="https://www.linkedin.com/company/preferred-square-analytics" aria-label="LinkedIn">
        <img src={linkedin} alt=''/>
      </NavLink>

    </div>

  </div>
</Container>

</footer>
    
    </>
  )
}

export default FooterNew